var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ControlBar", {
        attrs: {
          projectName: _vm.projectName,
          onFilters: true,
          filterId: _vm.filterId,
          dirty: _vm.dirty
        },
        on: { commit: _vm.commitChanges }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "pageRoot" }, [
        _vm.error
          ? _c("div", { staticClass: "error" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.error) + "\n\t\t\t"),
              _c("div", { staticClass: "tryAgain" }, [
                _c("input", {
                  attrs: { type: "button", value: "Try Again" },
                  on: { click: _vm.loadFilter }
                })
              ])
            ])
          : _vm.loading || _vm.filter
          ? _c("div", [
              _vm.filter
                ? _c("div", [
                    _c("div", { staticClass: "inputSection properties" }, [
                      _c("label", { staticClass: "inputLabel" }, [
                        _vm._v("Filter Properties")
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [_vm._v("ID:")]),
                        _vm._v(" " + _vm._s(_vm.filter.filter.FilterId))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          attrs: {
                            title:
                              "Since software version 2.3, this filter's actions have been run this many times."
                          }
                        },
                        [
                          _c("b", [_vm._v("Affected Event Count:")]),
                          _vm._v(" " + _vm._s(_vm.filter.eventCount))
                        ]
                      ),
                      _vm._v(" "),
                      _vm.filter.filter.UpdatedBy
                        ? _c(
                            "div",
                            {
                              class: {
                                lastModified: true,
                                viaToken:
                                  _vm.filter.filter.UpdatedBy.indexOf(
                                    "(via token"
                                  ) > -1
                              },
                              attrs: {
                                title:
                                  "Changes made by AI agents through the MCP endpoint are attributed to the API token they used."
                              }
                            },
                            [
                              _c("b", [_vm._v("Last Modified By:")]),
                              _vm._v(" " + _vm._s(_vm.filter.filter.UpdatedBy)),
                              _vm.filter.filter.UpdatedDate
                                ? _c("span", [
                                    _vm._v(" at " + _vm._s(_vm.updatedDateStr))
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter.filter.Name,
                              expression: "filter.filter.Name"
                            }
                          ],
                          class: {
                            primaryInput: true,
                            filterName: true,
                            searchMatched: _vm.searchMatched
                          },
                          attrs: {
                            type: "text",
                            placeholder: "Name",
                            title: "Name"
                          },
                          domProps: { value: _vm.filter.filter.Name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.filter.filter,
                                "Name",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "hint" }, [
                          _vm._v("← Filter Name")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.filter.Enabled,
                                expression: "filter.filter.Enabled"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.filter.filter.Enabled)
                                ? _vm._i(_vm.filter.filter.Enabled, null) > -1
                                : _vm.filter.filter.Enabled
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.filter.filter.Enabled,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.filter.filter,
                                        "Enabled",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.filter.filter,
                                        "Enabled",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.filter.filter, "Enabled", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" Enabled (run automatically on new events)")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.filter.ConditionHandling,
                                expression: "filter.filter.ConditionHandling"
                              }
                            ],
                            staticClass: "primaryInput",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.filter.filter,
                                  "ConditionHandling",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "All" } }, [
                              _vm._v("All conditions must match")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "Any" } }, [
                              _vm._v("At least one condition must match")
                            ]),
                            _vm._v(" "),
                            _c(
                              "option",
                              { attrs: { value: "Unconditional" } },
                              [
                                _vm._v(
                                  "Ignore conditions (always trigger actions)"
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputSection conditions" }, [
                      _c("label", { staticClass: "inputLabel" }, [
                        _vm._v("Conditions")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "conditionList" },
                        _vm._l(_vm.filter.conditions, function(condition) {
                          return _c("FilterCondition", {
                            key: condition.FilterConditionId,
                            staticClass: "condition",
                            attrs: {
                              condition: condition,
                              searchQuery: _vm.searchQuery,
                              regexSearch: _vm.regexSearch
                            },
                            on: { delete: _vm.deleteCondition }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          attrs: {
                            type: "button",
                            value: "New Condition (and Commit Changes)"
                          },
                          on: { click: _vm.newCondition }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inputSection actions" }, [
                      _c("label", { staticClass: "inputLabel" }, [
                        _vm._v("Actions")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "actionList" },
                        _vm._l(_vm.filter.actions, function(action) {
                          return _c("FilterAction", {
                            key: action.FilterActionId,
                            staticClass: "action",
                            attrs: {
                              action: action,
                              projectName: _vm.projectName,
                              searchQuery: _vm.searchQuery,
                              regexSearch: _vm.regexSearch
                            },
                            on: { delete: _vm.deleteAction }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("input", {
                          attrs: {
                            type: "button",
                            value: "New Action (and Commit Changes)"
                          },
                          on: { click: _vm.newAction }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "buttonBar" }, [
                      _c("input", {
                        attrs: { type: "button", value: "Commit Changes" },
                        on: { click: _vm.commitChanges }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "button", value: "Delete Filter" },
                        on: { click: _vm.beginDeleteFilter }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "button",
                          value: "Run filter against all events"
                        },
                        on: { click: _vm.runFilterAgainstAllEvents }
                      })
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c("div", { staticClass: "loadingOverlay" }, [
                    _c(
                      "div",
                      { staticClass: "loading" },
                      [_c("ScaleLoader"), _vm._v(" Loading…")],
                      1
                    )
                  ])
                : _vm._e()
            ])
          : _c("div", [
              _vm._v(
                "\n\t\t\tFailed to load filter " +
                  _vm._s(_vm.filterId) +
                  " in project: " +
                  _vm._s(_vm.projectName) +
                  "\n\t\t\t"
              ),
              _c("div", { staticClass: "tryAgain" }, [
                _c("input", {
                  attrs: { type: "button", value: "Try Again" },
                  on: { click: _vm.loadFilter }
                })
              ])
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notes" }, [
      _c("div", { staticClass: "notesHeading" }, [_vm._v("Filter Notes")]),
      _vm._v(" "),
      _c("div", { staticClass: "notesBody" }, [
        _c("ul", [
          _c("li", [
            _vm._v("When deleting "),
            _c("b", [_vm._v("conditions")]),
            _vm._v(" or "),
            _c("b", [_vm._v("actions")]),
            _vm._v(", changes are committed for the entire "),
            _c("b", [_vm._v("filter")]),
            _vm._v(".")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Disabled "),
            _c("b", [_vm._v("filters")]),
            _vm._v(" can still be run manually.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Disabled "),
            _c("b", [_vm._v("conditions")]),
            _vm._v(
              " and actions are ignored (as if they did not exist) when executing the "
            ),
            _c("b", [_vm._v("filter")]),
            _vm._v(".")
          ]),
          _vm._v(" "),
          _c("li", [
            _c("code", { staticClass: "inline" }, [
              _vm._v("All conditions must match")
            ]),
            _vm._v(" mode requires at least one "),
            _c("b", [_vm._v("condition")]),
            _vm._v(" to match.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("In "),
            _c("b", [_vm._v("conditions")]),
            _vm._v(", the "),
            _c("code", { staticClass: "inline" }, [_vm._v("Field Name")]),
            _vm._v(" and "),
            _c("code", { staticClass: "inline" }, [_vm._v("Query")]),
            _vm._v(" fields are case-insensitive.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("A "),
            _c("b", [_vm._v("condition's")]),
            _vm._v(" "),
            _c("code", { staticClass: "inline" }, [_vm._v("Field Name")]),
            _vm._v(" field can be "),
            _c("code", { staticClass: "inline" }, [_vm._v("EventType")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("SubType")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("Message")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("Date")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("Folder")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("Color")]),
            _vm._v(", or any application-specific tag key. An empty "),
            _c("code", { staticClass: "inline" }, [_vm._v("Field Name")]),
            _vm._v(" will fail the condition.")
          ]),
          _vm._v(" "),
          _c("li", [
            _c("b", [_vm._v("Actions")]),
            _vm._v(" are executed in the order they are defined above.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("The "),
            _c("b", [_vm._v("action")]),
            _vm._v(" "),
            _c("code", { staticClass: "inline" }, [
              _vm._v("stop execution against matched event")
            ]),
            _vm._v(" prevents other "),
            _c("b", [_vm._v("filters")]),
            _vm._v(" and "),
            _c("b", [_vm._v("actions")]),
            _vm._v(
              " from executing against the matched event for the remainder of the current filtering operation."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("The "),
            _c("b", [_vm._v("action")]),
            _vm._v(" "),
            _c("code", { staticClass: "inline" }, [_vm._v("move event to")]),
            _vm._v(" requires an absolute folder path (e.g. "),
            _c("code", { staticClass: "inline" }, [_vm._v("/ignored/spam")]),
            _vm._v(
              ").  If the path is invalid or fails to resolve (case-insensitive), the event will not be moved."
            )
          ]),
          _vm._v(" "),
          _c("li", [_c("b", [_vm._v("Actions")]), _vm._v(" affect all users.")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }